import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Button from 'react-toolbox/lib/button';
import { Card, CardText } from 'react-toolbox/lib/card';
import callApi from '../../../common/call-api';
import withQuery from '../../../common/components/withQuery';

const CustomCard = glamorous(Card, {
  rootEl: 'div',
  forwardProps: ['children', 'className', 'raised'],
})({
  textAlign: 'center',
});

const Message = glamorous.h3({
  fontSize: '2.8rem',
  marginBottom: '20px',
  fontWeight: 'normal',
});

const redirectToNFIB = () => {
  window.location.href = 'https://www.nfib.com';
};

export class ValidateEmail extends React.Component {
  constructor() {
    super();
    this.state = {
      message: 'Loading',
    };
  }

  componentWillMount() {
    const { location: { query: {token = '', cst = ''} = {}} } = this.props;
    const invalidParam = param => {
      return !param || typeof param !== 'string' || param.length === 0;
    }
    if (invalidParam(token) || invalidParam(cst)) {
      this.setState({ message: 'Token and Customer Key parameters must be valid strings.' });
    } else {
      callApi(
        `api/cuss/2.0/individuals/${cst}/ContactDetails/EmailAddress/Verification?token=${token}`, 
        {
          method: 'PUT',
        },
      ).then(
          ({json}) => 
            json.isEmailAddressVerified
              ? 'Thank you for validating your email address.'
              : (json.message || "You've reached the page in error.")
        )
        .then(message => this.setState({ message }))
        .catch(({ json: {message} }) => this.setState({ message }));
    }
  }

  render() {
    return (
      <CustomCard>
        <CardText>
          <Message>{this.state.message}</Message>
          <Button
            accent
            raised
            label="Go To NFIB.com"
            onClick={redirectToNFIB}
          />
        </CardText>
      </CustomCard>
    );
  }
}

ValidateEmail.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      token: PropTypes.string,
      cst: PropTypes.string,
    }),
  }),
  actions: PropTypes.object,
};

ValidateEmail.defaultProps = {
  token: '',
  cst: '',
};

export default withQuery(ValidateEmail);



// WEBPACK FOOTER //
// ./src/App/users/Views/EmailValidation.js